<template>
  <header class="header">
    <div class="headerBox">
      <div class="logo">
        <img src="https://cyvideo.i-oranges.com/home/icon/logo.png" alt="橙意机构" />
      </div>
      <nav>
        <ul>
          <li v-for="(item, index) in menuItems" :key="index">
            <router-link :to="item.link">
              <div class="text-center" @mouseenter="hoverIndex = index" @mouseleave="hoverIndex = null">
                <div class="text-wrapper">
                  <span :class="{ 'scroll-up': hoverIndex === index, 'scroll-down': hoverIndex !== index }">
                    <span>{{ item.text_zh }}</span>
                    <span>{{ item.text_en }}</span>
                  </span>
                </div>
                <span v-if="$route.path === item.link" class="underline"></span>
              </div>
            </router-link>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>

export default {
  name: "HeaderComponent",
  data() {
    return {
      hoverIndex: null,
      menuItems: [
        { text_zh: '首页', text_en: 'HOME', link: '/' },
        { text_zh: '案例展示', text_en: 'WORK', link: '/work' },
        { text_zh: '关于我们', text_en: 'ABOUT', link: '/about' },
        { text_zh: '联系我们', text_en: 'CONTACT', link: '/contact' }
      ]
    };
  }
}
</script>

<style scoped>
.header {
  padding: 20px;
  background: #141414;
}
.headerBox {
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ff6600;
}
.logo img {
  height: 96px;
}
nav ul {
  list-style: none;
  display: flex;
  gap: 50px;
}
nav a {
  color: #ff6600;
  text-decoration: none;
  position: relative;
  transition: transform 0.2s;
  font-size: 20px;
  letter-spacing: 2px;
  font-family: ali_R;
}
nav a.active, nav a:hover {
  color: #FF6600;
  transform: scale(1.1);
}
.underline {
  display: block;
  height: 3px;
  background: #FF6600;
  position: absolute;
  bottom: -20px;
  border-radius: 10px;
  left: 0;
  width: 100%;
  animation: expand 0.5s forwards;
}
@keyframes expand {
  from { width: 0; }
  to { width: 100%; }
}

/* 滚动切换效果 */
.text-wrapper {
  overflow: hidden;
  height: 24px; /* 控制高度以适应文字大小 */
  display: inline-block;
  vertical-align: middle;
}
.scroll-up, .scroll-down {
  display: flex;
  flex-direction: column;
  transition: transform 0.3s ease-out;
}
.scroll-up {
  transform: translateY(-50%);
}
.scroll-down {
  transform: translateY(0);
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderComponent.vue